import React from "react";
import Modal from "react-modal";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface PurgeInvoicesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPurging: boolean;
}

const PurgeInvoicesModal: React.FC<PurgeInvoicesModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isPurging,
}) => {
  return (
    <Modal
      className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-lg p-6 w-[calc(100%-32px)] max-w-[500px] bg-white dark:bg-slate-800 shadow-[0_10px_25px_rgba(0,0,0,.3)] outline-none overflow-y-auto"
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="fixed inset-0 bg-black/30 z-[9999]"
    >
      <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
        Purge Imported Invoices
      </h3>

      <div className="py-4">
        <p className="text-gray-600 dark:text-gray-400 mb-4">
          Are you sure you want to purge all imported invoices.
        </p>

        <div className="p-4 bg-red-50 dark:bg-red-900/20 border border-red-300 dark:border-red-800 rounded-lg">
          <div className="flex items-start">
            <AlertTriangle className="w-5 h-5 text-red-600 dark:text-red-400 mr-3 mt-0.5" />
            <div className="text-sm text-red-800 dark:text-red-300">
              <p className="font-semibold mb-2">Warning:</p>
              <ul className="space-y-1">
                <li>• This will permanently purge all imported invoice data</li>
                <li>• This action cannot be undone</li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-sm text-gray-600 dark:text-gray-400">
          Are you sure you want to proceed?
        </p>
      </div>

      <div className="mt-6 flex justify-end space-x-3">
        <Button disabled={isPurging} onClick={onClose} variant="outline">
          Cancel
        </Button>

        <Button disabled={isPurging} onClick={onConfirm}>
          {isPurging ? "Purging..." : "Purge Invoices"}
        </Button>
      </div>
    </Modal>
  );
};

export default PurgeInvoicesModal;
